'use strict';
var isPrototypeOf = require('../internals/object-is-prototype-of');

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-instance.js
// module id = 98
// module chunks = 0